import debounce from 'lodash.debounce';

import { getViewport } from './scripts/utils';
import initGallery from './scripts/galleries';
import initPageGallery from './scripts/pageGallery';
import initCollapsibleContent from './scripts/collapsibleContent';
import filterVendors from './scripts/filterVendors';
import initFormField from './scripts/formFields';

import initAlert from './scripts/alert';

initAlert();

const navbar = document.getElementById('navbar');
const navbarToggler = document.getElementById('navbarToggler');

function toggleNav() {
  if (navbar.classList.contains('open')) {
    navbar.classList.remove('open');
    // enableScroll();
  } else {
    navbar.classList.add('open');
    // disableScroll();
  }
}

navbarToggler.addEventListener('click', toggleNav);

function getScrollY() {
  return window.scrollY || window.pageYOffset || document.body.scrollTop;
}

function toggleTopOfPage(e) {
  const scrollY = getScrollY();
  if (scrollY) {
    navbar.classList.remove('top');
  } else {
    navbar.classList.add('top');
  }
}

const viewport = getViewport();

if (
  document.body.classList.contains('page-template-template-special') &&
  viewport.width >= 768
) {
  toggleTopOfPage();
  window.addEventListener('scroll', debounce(toggleTopOfPage));
}

const contentSliderBlocks = document.querySelectorAll('.content-slider.block');
contentSliderBlocks.forEach((block, i) => {
  // const evenOdd = i % 2 === 0 ? 'even' : 'odd';
  const evenOdd = i % 2 === 0 ? 'odd' : 'even';
  block.classList.add(evenOdd);
  const gallery = block.querySelector('.gallery');
  gallery.classList.add(evenOdd);
});

const galleries = document.querySelectorAll('.gallery');
if (galleries) galleries.forEach(initGallery);

const pageGallery = document.querySelector('.page-gallery.init-gallery');
if (pageGallery) initPageGallery(pageGallery);

const collapsibleContent = document.querySelectorAll('.collapsible-content');
collapsibleContent.forEach(initCollapsibleContent);

const vendorSection = document.querySelector('.vendors');
if (vendorSection) filterVendors(vendorSection);

const formfields = document.querySelectorAll('.gfield');
formfields.forEach(initFormField);

// check for both multiline and gallery

const page = document.querySelector('.type-page');
if (page) {
  const header = page.querySelector('.page-header');
  const title = page.querySelector('.page-title');
  const fontHeight = 60;
  const lineHeight = 1.15;
  if (title.getBoundingClientRect().height >= fontHeight * lineHeight * 2) {
    header.style.paddingBottom = '7rem';
  }
}
